import { useMemo } from "react";
import { Outlet } from "react-router-dom";
import SingleTab from "../../../../components/singleTab/singleTab";
import { CmmInputUniqueValuesProvider } from "../../../../context/cmmInputUniqueValuesContext";

const ValidationFunnel = () => {
  const tabs = useMemo(
    () => [
      { id: "first-stp-logic", label: "First STP Review" },
      { id: "second-stp-logic", label: "Second STP Review" },
      { id: "agentic-logic", label: "Agentic" },
      { id: "condition-list", label: "Fields" },
      { id: "playground", label: "Playground" },
    ],
    [],
  );

  return (
    <CmmInputUniqueValuesProvider>
      <div className="validation-funnel-layout flex h-full flex-col overflow-hidden">
        <div className="validation-funnel-layout__header flex flex-row items-center justify-between border-b border-primaryGray-15 px-6 pb-4 pt-1 font-semibold">
          <div className="validation-funnel-layout__header-title">
            <div className="font-bold">No Touch Config</div>
            <div className="text-small font-light text-primaryGray-7">
              Configure human-review rules before send-to-plan
            </div>
          </div>
          {/* <div className="flex flex-row gap-2">
          <Button
            buttonType="secondary"
            size="medium"
            onClick={() => {}}
            disabled={false}
            children="Discard"
          />
          <Button
            buttonType="primary"
            size="medium"
            onClick={() => {}}
            disabled={false}
            children="Save Changes"
          />
        </div> */}
        </div>
        <div className="validation-funnel-layout__tabs mb-2 flex flex-row border-b border-primaryGray-16 px-6">
          {tabs.map((tab) => (
            <SingleTab key={tab.id} id={tab.id} label={tab.label} />
          ))}
        </div>
        <div className="validation-funnel-layout__content flex min-h-0 flex-1 flex-col overflow-hidden px-6">
          <Outlet />
        </div>
      </div>
    </CmmInputUniqueValuesProvider>
  );
};

export default ValidationFunnel;
